import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import axios from 'axios';
import { API } from '../App';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to fetch settings');
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-card border-t border-border mt-20" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="/ambika-logo.jpg" alt="Ambika Fashion" className="h-16 w-auto mb-4" />
            <p className="text-muted-foreground leading-relaxed">
              {settings?.site_description || 'Premium B2B wholesale platform for traditional Indian ethnic wear. Serving retailers and boutiques worldwide.'}
            </p>
          </div>

          {/* Quick Links */}
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/products" className="block text-muted-foreground hover:text-primary transition-colors">
                Collections
              </Link>
              <Link to="/dashboard" className="block text-muted-foreground hover:text-primary transition-colors">
                Dashboard
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              {(settings?.contact_address) && (
                <div className="flex items-start space-x-3 text-muted-foreground">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <span data-testid="footer-address">{settings.contact_address}</span>
                </div>
              )}
              {(settings?.contact_phone) && (
                <div className="flex items-center space-x-3 text-muted-foreground">
                  <Phone size={18} className="flex-shrink-0" />
                  <span data-testid="footer-phone">{settings.contact_phone}</span>
                </div>
              )}
              {(settings?.contact_email) && (
                <div className="flex items-center space-x-3 text-muted-foreground">
                  <Mail size={18} className="flex-shrink-0" />
                  <span data-testid="footer-email">{settings.contact_email}</span>
                </div>
              )}
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/share/18M7pNz61V/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook" data-testid="social-facebook">
                <Facebook size={24} />
              </a>
              <a href="https://www.instagram.com/ambika_fashion_kolkata/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram" data-testid="social-instagram">
                <Instagram size={24} />
              </a>
              <a 
                href={`https://wa.me/${settings?.whatsapp_number || '917980063435'}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-muted-foreground hover:text-[#25D366] transition-colors" 
                aria-label="WhatsApp" 
                data-testid="social-whatsapp"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-center text-muted-foreground">
          <p>&copy; 2026 Ambika Fashion. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
